import React from 'react';

import LayoutContext from './LayoutContext';
import useLayout from './useLayout';

type Props = {
  children: React.ReactNode;
  value: any;
};

const LayoutProvider: React.FunctionComponent<Props> = ({ value, children }) => {
  const layout = useLayout();
  return (
    <LayoutContext.Provider value={value ? { ...layout, ...value } : layout}>
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutProvider;
